import { render, staticRenderFns } from "./InternationalInterests.vue?vue&type=template&id=2a0ad466"
import script from "./InternationalInterests.vue?vue&type=script&lang=js"
export * from "./InternationalInterests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports